// @ts-nocheck
import useAppDispatch from "@insite/client-framework/Common/Hooks/useAppDispatch";
import StyledWrapper from "@insite/client-framework/Common/StyledWrapper";
import siteMessage from "@insite/client-framework/SiteMessage";
import translate from "@insite/client-framework/Translate";
import Checkbox, { CheckboxProps } from "@insite/mobius/Checkbox";
import Typography, { TypographyPresentationProps } from "@insite/mobius/Typography";
import InjectableCss from "@insite/mobius/utilities/InjectableCss";
import updateDraftParameter from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/Handlers/UpdateDraftParameter";
import { useTrailerTrackingV2State } from "@store/Framework/Store/Greif/Pages/TrailerTrackingV2/TrailerTrackingV2Hooks";
import FilterDrawerSection from "@store/Library/Components/FilterDrawerSection";
import { filterDrawerProps } from "@store/Themes/common/props/filterDrawer";
import React, { FC } from "react";

export interface TrailerTrackingV2FilterFieldLocationsProps {}

export interface TrailerTrackingV2FilterFieldLocationsStyles {
    fieldWrapper?: InjectableCss;
    checkbox?: CheckboxProps;
    checkboxDescription?: TypographyPresentationProps;
}

export const trailerTrackingV2FilterFieldLocationsStyles: TrailerTrackingV2FilterFieldLocationsStyles = {
    fieldWrapper: filterDrawerProps.fieldWrapper,
    checkbox: filterDrawerProps.toggleCheckbox,
    checkboxDescription: filterDrawerProps.toggleCheckboxDescription,
};

const styles = trailerTrackingV2FilterFieldLocationsStyles;

const trailerTrackingV2FilterFieldLocations: FC<TrailerTrackingV2FilterFieldLocationsProps> = () => {
    const dispatch = useAppDispatch();
    const { alertsOnly, onSiteOnly } = useTrailerTrackingV2State().draftParameter;

    return (
        <FilterDrawerSection title={translate("Ship To Locations")} isAccordion={true}>
            <StyledWrapper {...styles.fieldWrapper}>
                <Checkbox
                    {...styles.checkbox}
                    checked={alertsOnly}
                    onChange={(event, value) => {
                        dispatch(updateDraftParameter({ alertsOnly: value }));
                    }}
                >
                    {translate("Only Locations with Alerts")}
                    <Typography {...styles.checkboxDescription}>
                        {siteMessage("DropTrailer_Filter_AlertsOnly_Info")}
                    </Typography>
                </Checkbox>
            </StyledWrapper>
            <StyledWrapper {...styles.fieldWrapper}>
                <Checkbox
                    {...styles.checkbox}
                    checked={onSiteOnly}
                    onChange={(event, value) => {
                        dispatch(updateDraftParameter({ onSiteOnly: value }));
                    }}
                >
                    {translate("Only locations with drop trailers on site")}
                    <Typography {...styles.checkboxDescription}>
                        {siteMessage("DropTrailer_Filter_OnSiteOnly_Info")}
                    </Typography>
                </Checkbox>
            </StyledWrapper>
        </FilterDrawerSection>
    );
};

export default trailerTrackingV2FilterFieldLocations;
